import { useMutation } from '@tanstack/react-query';
import { postUnmap } from '../lib/suggestions-api';
import { useInvalidateMapping } from './use-invalidate-mapping';

/** Undo: a mapped listing goes back to the queue. */
export function useUnmapListing() {
  const invalidate = useInvalidateMapping();

  return useMutation({
    mutationFn: (listingId: string) => postUnmap(listingId),
    onSettled: invalidate,
  });
}
